export enum VoucherType {
  Cash = 'Cash',
  Promo = 'Promo',
  Referral = 'Referral',
}